import { TConfigs, TCSSPosition, TPlacement, TPosition } from '../types'
import { getElementClientRectByPosition } from '../helpers'

interface IProps {
    placement: TPlacement
    position: TCSSPosition
    reference: HTMLElement
    popup: HTMLElement
    popupConfigs?: TConfigs
    shiftValues: TPosition
}

export default function getPosition(options: IProps): TPosition {
    const { placement, position, reference, popup, popupConfigs, shiftValues } = options
    const { offset = 0 } = popupConfigs || {}
    const referenceRect = getElementClientRectByPosition(reference, position)
    const popupRect = getElementClientRectByPosition(popup, position)
    const xPos = referenceRect.x
    const yPos = referenceRect.y
    const referenceHeight = referenceRect.height
    const referenceWidth = referenceRect.width
    const popupHeight = popupRect.height
    const popupWidth = popupRect.width

    const returnPosition: TPosition = {
        x: 0,
        y: 0
    }

    /*
     * Calculate y position
     * */
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            returnPosition.y = yPos - (popupHeight + offset)
            break
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            returnPosition.y = yPos + referenceHeight + offset
            break
        case 'left-start':
        case 'right-start':
            returnPosition.y = yPos
            break
        case 'left':
        case 'right':
            returnPosition.y = yPos + referenceHeight / 2 - popupHeight / 2
            break
        case 'left-end':
        case 'right-end':
            returnPosition.y = yPos + referenceHeight - popupHeight
            break
    }

    /*
     * Calculate x position
     * */
    switch (placement) {
        case 'left-start':
        case 'left':
        case 'left-end':
            returnPosition.x = xPos - (popupWidth + offset)
            break
        case 'right-start':
        case 'right':
        case 'right-end':
            returnPosition.x = xPos + referenceWidth + offset
            break
        case 'top-start':
        case 'bottom-start':
            returnPosition.x = xPos
            break
        case 'top':
        case 'bottom':
            returnPosition.x = xPos + referenceWidth / 2 - popupWidth / 2
            break
        case 'top-end':
        case 'bottom-end':
            returnPosition.x = xPos + referenceWidth - popupRect.width
            break
    }

    /*
     * Add shift values
     * */
    returnPosition.x -= shiftValues.x
    returnPosition.y -= shiftValues.y

    return returnPosition
}
